import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import * as fromGenerated from '../../../_generated';
import { NavigationTeammateComponent } from './navigation-teammate.component';

@Component({
  selector: 'squadbox-navigation-teammates-list-smart',
  imports: [NavigationTeammateComponent],
  template: `
    <div class="flex flex-col">
      @for (teammate of teammatesList(); track teammate.id) {
        <squadbox-navigation-teammate
          [slug]="teammate.slug"
          [teammate]="teammate"
          [active]="getNavigationActiveStateBySlug(teammate.slug)"
          (click)="teammateClicked.emit()"
        >
        </squadbox-navigation-teammate>
      }
      <squadbox-navigation-teammate
        slug="my-skills"
        [active]="getNavigationActiveStateBySlug('my-skills')"
        (click)="teammateClicked.emit()"
      >
      </squadbox-navigation-teammate>
    </div>
  `,
})
export class NavigationTeammatesListSmartComponent {
  private readonly router = inject<Router>(Router);

  public readonly teammatesList =
    input.required<fromGenerated.TeammateView[]>();
  public readonly teammateClicked = output<void>();

  public getNavigationActiveStateBySlug(slug: string): boolean {
    if (slug === 'my-skills') {
      return this.router.url.includes('/chats/assistants');
    }
    return this.router.url.includes(`/chats/teammates/${slug}`);
  }
}
